
import styles from './Recommends.module.css';


// Import your images
import result1 from "../../images/אוקסנה בראל המלצות 1.png";
import result2 from "../../images/אוקסנה בראל המלצות 2.png";
import result3 from "../../images/אוקסנה בראל המלצות 3.png";
import result4 from "../../images/אוקסנה בראל המלצות 4.png";
import result5 from "../../images/אוקסנה בראל המלצות 5.png";
import result6 from "../../images/אוקסנה בראל המלצות 6.png";
import result7 from "../../images/אוקסנה בראל המלצות 7.png";
import Button from '../button/Button';
const Recs = () => {
  const images = [
  result1, result2, result3, result4, result5, result6, , result7
  ];

  return (
    <>

     <div className={styles.explain}>
ומה קורה אחרי הטיפולים? זה נראה ככה:
      </div>
   
      <div className={styles.container}>
        <div className={styles.scrollTrack}>
          {/* קבוצה ראשונה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`first-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
          {/* קבוצה שנייה זהה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`second-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
  <Button text="לחצי כאן ליצירת קשר"/>
    </>
  );
};

export default Recs;